import { IconButton } from "@mui/material";
import useDotLegalNote from "./DotLegalNote.hooks";
import { NoteWithDataIcon, NoteSVG } from "../../icons";
import DotLegalNoteDialog from "./dotLegalNoteDialog/DotLegalNoteDialog";
import { EntityType } from "../../Common.types";

export interface IDotLegalNoteProps {
    disabled?: boolean;
    entityId?: string;
    entityType?: EntityType;
    note?: string;
    onNoteUpdated: () => void;
    postUrl?: string;
    label?: string;
    header?: string;
    errorText?: string;
}

function DotLegalNote(props: IDotLegalNoteProps) {
    const { setShowDialog, showDialog } = useDotLegalNote();

    function getIcon() {
        if (props.note) {
            return NoteWithDataIcon;
        }

        return NoteSVG;
    }

    function onNoteUpdated() {
        props.onNoteUpdated();
        setShowDialog(false);
    }

    return (
        <>
            <IconButton onClick={() => setShowDialog(true)}>{getIcon()}</IconButton>

            {showDialog && (
                <DotLegalNoteDialog
                    {...props}
                    disabled={props.disabled}
                    postUrl={props.postUrl}
                    showDialog={showDialog}
                    noteText={props.note}
                    onDialogClose={() => setShowDialog(false)}
                    onNoteUpdated={() => onNoteUpdated()}
                />
            )}
        </>
    );
}

export default DotLegalNote;
